import script from "./CourseProposition.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseProposition.vue?vue&type=script&setup=true&lang=ts"

import "./CourseProposition.vue?vue&type=style&index=0&id=8f51acca&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f51acca"]])

export default __exports__